var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',[_c('div',[_c('span',{staticClass:"ml-1"},[_vm._v("© 2018 ")]),_c('a',{attrs:{"href":"https://www.silompos.com/","target":"_blank","rel":"noopener"}},[_vm._v(" Silom Technology ")]),_c('span',[_vm._v(" - ALL RIGHTS RESERVED ")])]),_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"mr-1"},[_vm._v("version 1.0.0")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }